/**
 * 명치사 앱 스토어 링크와 기기 판별.
 *
 * 카페·메일·QR 등 외부에서는 스토어 URL을 직접 쓰지 않고 브릿지(`/app`) 하나만 안내한다 —
 * 브릿지가 기기에 맞는 스토어로 보내고, 스토어 URL이 바뀌어도 외부 본문을 고칠 필요가 없다.
 */
export const APP_STORE_URL: string = 'https://apps.apple.com/kr/app/id6807718357';
export const PLAY_STORE_URL: string = 'https://play.google.com/store/apps/details?id=com.myungchisa.app';
export const APP_BRIDGE_PATH: string = '/app';

/** 공식 스토어 배지·QR 이미지 (S3 images/, CloudFront 로 서빙). 카페·메일에서도 같은 파일을 쓴다. */
export const APP_BADGE_APPSTORE_PNG: string = '/images/app-badge/appstore-ko.png';
export const APP_BADGE_GOOGLEPLAY_PNG: string = '/images/app-badge/googleplay-ko.png';
export const APP_QR_PNG: string = '/images/app-badge/app-qr.png';

export type MobileOs = 'ios' | 'android' | 'other';

/**
 * UA 기반 모바일 OS 판별. iPadOS 13+ 는 Macintosh UA 를 보내므로 터치포인트로 보정한다.
 */
export function detectMobileOs(ua: string = navigator.userAgent): MobileOs {
    if (/android/i.test(ua)) return 'android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
    if (/Macintosh/i.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1) return 'ios';
    return 'other';
}

/** OS 에 맞는 스토어 URL. PC 등은 null (브릿지 페이지에서 QR·배지로 안내). */
export function storeUrlFor(os: MobileOs): string | null {
    if (os === 'ios') return APP_STORE_URL;
    if (os === 'android') return PLAY_STORE_URL;
    return null;
}
